import { getValue, compareValue, parseDate } from '../utils/formValue';
export default function initCompareToValidator() {

    $.validator.addMethod("compareto",
        function (value, element, params) {
            if ((params["type"] == "System.DateTime" || params["type"] == "System.DateOnly") && parseDate(value) == null) return true; //Continue if not parsed correctly. let date.js handle this

            var name1 = params["compareproperty"];
            var valueToCompare1 = getValue(name1);

            // compare targetvalue to compareproperty or value
            var comparisonIsOk = typeof value !== 'undefined' && value !== '' ? compareValue(
                value,
                params["operator"],
                valueToCompare1,
                params["type"],
                params
            ) : true;

            return comparisonIsOk;
        })

    $.validator.unobtrusive.adapters.add("compareto", ["compareproperty", "operator", "type", "dateformat", "decimalchar"],
        function (options) {
            options.rules['compareto'] =
            {
                compareproperty: options.params.compareproperty,
                operator: options.params.operator,
                type: options.params.type,
                dateformat: options.params.dateformat,
                decimalchar: options.params.decimalchar
            };
            options.messages['compareto'] = options.message;
        }
    );
}
